import { AdData, AdParam } from '@olxpwa-lib/utils-ad/types';

export const trackAdParams = (ad: AdData | null) => ({
    is_inactive: ad?.isActive ? !ad.isActive : null,
    region_id: ad?.location?.regionId,
    region_name: ad?.location?.regionName,
    city_id: ad?.location?.cityId,
    city_name: ad?.location?.cityName,
    district_id: ad?.location?.districtId,
    sell_with_delivery: ad?.delivery?.rock?.mode === 'BuyWithDelivery',
    ad_id: ad?.id,
    category_id: ad?.category?.id,
    ad_photo: ad?.photos ? ad?.photos.length : 0,
    seller_id: ad?.user?.id,
    poster_type: ad?.isBusiness ? 'business' : 'private',
    num_listing_atts: (ad?.params || []).length,
    listing_atts: (ad?.params || []).map((v: AdParam) => v.key),
    ad_featured: (ad?.promotion?.options || []).length
        ? `[${ad?.promotion?.options?.toString()}]`
        : null
});
